import React, { useContext, createContext, useState, FC, Dispatch, SetStateAction } from 'react';
import { IUserDetail } from './userContext';

export interface IRegistrationContext {
  userDetails?: IUserDetail;
  setUserRegistrationDetails?: Dispatch<SetStateAction<IUserDetail>>;
  registeredUserDetails?: any;
  setRegisteredUserDetails?: Dispatch<SetStateAction<any>>;
}

const RegistrationContext = createContext<IRegistrationContext>({});
const RegistrationWrapper: FC = ({ children }) => {
  const [registeredUserDetails, setRegisteredUserDetails] = useState({});
  return (
    <RegistrationContext.Provider
      value={{
        registeredUserDetails,
        setRegisteredUserDetails,
      }}
    >
      {children}
    </RegistrationContext.Provider>
  );
};
const useRegistrationContext = () => useContext(RegistrationContext);

export { RegistrationWrapper, useRegistrationContext };
